'use client';

import React from 'react';

export const useLatest = <T extends unknown>(value: T): React.MutableRefObject<T> => {
  const ref = React.useRef<T>(value);
  ref.current = value;
  return ref;
};
